import type { Logger } from './use-logger';

export class ConsoleLogger implements Logger {
  private log(
    level: 'debug' | 'info' | 'warn' | 'error',
    message: string | Error,
    details?: Record<string, unknown>,
  ): void {
    if (details == null) {
      console[level](message);
    } else {
      console[level](message, details);
    }
  }

  public debug(message: string | Error, details?: Record<string, unknown>): void {
    this.log('debug', message, details);
  }

  public info(message: string | Error, details?: Record<string, unknown>): void {
    this.log('info', message, details);
  }

  public warn(message: string | Error, details?: Record<string, unknown>): void {
    this.log('warn', message, details);
  }

  public error(message: string | Error, details?: Record<string, unknown>): void {
    this.log('error', message, details);
  }

  public fatal(message: string | Error, details?: Record<string, unknown>): void {
    this.log('error', message, details);
  }
}
